import { AlertTriangle } from "lucide-react"
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from "../Dialog/Dialog"
import { Button } from "../Button/Button"

export interface RiskDisclaimerProps {
  open: boolean
  onAcknowledge: () => void
  onOpenChange: (open: boolean) => void
  acknowledgeLabel?: string
  title?: string
  className?: string
}

export function RiskDisclaimer({
  open,
  onAcknowledge,
  onOpenChange,
  acknowledgeLabel = "I Understand",
  title = "Risk Disclaimer",
  className,
}: RiskDisclaimerProps) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className={`v1 sm:max-w-md bg-card border-border ${className ?? ""}`} showCloseButton={false}>
        <DialogHeader>
          <div className="flex items-center gap-2.5">
            <div className="w-9 h-9 rounded-md bg-muted border border-border flex items-center justify-center shrink-0">
              <AlertTriangle size={16} strokeWidth={1.75} className="text-danger" />
            </div>
            <DialogTitle className="text-body-strong text-foreground">{title}</DialogTitle>
          </div>
        </DialogHeader>

        <DialogDescription asChild>
          <div className="flex flex-col gap-2.5 text-body text-muted-foreground">
            <p>
              The code generated here is provided for{" "}
              <strong className="text-foreground font-semibold">
                educational and research purposes only
              </strong>
              . It does not constitute financial advice, investment recommendation, or a solicitation
              to trade.
            </p>
            <p>
              Algorithmic trading involves substantial risk of loss.{" "}
              <strong className="text-foreground font-semibold">
                Past performance is not indicative of future results.
              </strong>{" "}
              Backtest results are simulated and may not reflect actual market conditions, slippage, or
              execution delays.
            </p>
            <p>
              You are solely responsible for any trading decisions made using this code. Always conduct
              your own due diligence and consider consulting a qualified financial advisor before
              deploying any trading strategy with real capital.
            </p>
          </div>
        </DialogDescription>

        <Button
          onClick={() => {
            onAcknowledge()
            onOpenChange(false)
          }}
          className="w-full"
        >
          {acknowledgeLabel}
        </Button>
      </DialogContent>
    </Dialog>
  )
}
